import { useState } from "react";
import type { FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { allSoftware, formatDownloads } from "@/utils/software";

export default function HeroSection() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const totalDownloads = allSoftware.reduce((sum, item) => sum + item.downloads, 0);
  const avgRating = (allSoftware.reduce((sum, item) => sum + item.rating, 0) / allSoftware.length).toFixed(1);

  const stats = [
    { label: "收录软件", value: `${allSoftware.length}+ 款` },
    { label: "累计下载", value: formatDownloads(totalDownloads) },
    { label: "平均评分", value: `${avgRating} 分` },
    { label: "更新时间", value: "2026.10" },
  ];

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <section className="relative overflow-hidden bg-secondary-950">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20luxury%20gold%20and%20deep%20navy%20financial%20background%20with%20flowing%20golden%20particles%20and%20subtle%20candlestick%20chart%20silhouettes%2C%20elegant%20dark%20gradient%2C%20premium%20banking%20aesthetic%2C%20soft%20bokeh%2C%20cinematic%20high%20detail&width=1920&height=900&seq=hero-gold-2026&orientation=landscape"
        alt="金色与藏青风格的黄金投资主题背景"
        title="黄金投资软件下载"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-secondary-950/85 via-secondary-950/80 to-secondary-950/95" />
      <div className="absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-500/20 blur-3xl animate-glow" />
      <div className="absolute -right-16 bottom-0 h-64 w-64 rounded-full bg-accent-500/15 blur-3xl animate-glow" />

      <div className="relative container-page py-16 md:py-24">
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-5 text-center">
          <span className="chip border border-primary-500/40 bg-primary-500/10 text-primary-200">
            <i className="ri-shield-check-line" />
            权威推荐 · 免费下载 · 持续更新
          </span>
          <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 text-balance md:text-5xl">
            发现优质黄金投资软件，一键免费下载
          </h1>
          <p className="max-w-2xl text-sm leading-relaxed text-background-300 md:text-base">
            汇聚趋势分析、价格监控、理财工具与行情资讯四大类黄金投资软件，帮助散户投资者快速找到实用工具，轻松掌握黄金市场行情与价格走势。
          </p>

          <form
            onSubmit={submit}
            role="search"
            className="mt-2 flex w-full max-w-xl items-center gap-2 rounded-lg border border-secondary-700 bg-secondary-900/70 p-1.5 backdrop-blur"
          >
            <i className="ri-search-line ml-2 text-lg text-primary-300" aria-hidden="true" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="search"
              placeholder="输入关键词，如「黄金行情」「价格监控」"
              aria-label="搜索黄金投资软件"
              className="h-10 flex-1 bg-transparent text-sm text-background-50 outline-none placeholder:text-background-400"
            />
            <button type="submit" className="btn-primary h-10 px-5">
              搜索软件
            </button>
          </form>

          <div className="mt-4 grid w-full max-w-2xl grid-cols-2 gap-4 border-t border-secondary-800 pt-6 sm:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.label} className="flex flex-col items-center gap-1">
                <span className="font-heading text-xl font-bold text-primary-300 md:text-2xl">
                  {stat.value}
                </span>
                <span className="text-xs text-background-400">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}